

export const country: any[]= [
  { name: 'Chile' },
  {name: 'Colombia' },
  {name:'Otros'}
 
];